"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AudioContent;

function AudioContent() {
  return {
    width: '100%'
  };
}